export const MaxLength100Symbols = 100;
export const MaxLength50Symbols = 50;
export const MaxLength40Symbols = 40;
export const MaxLength8Symbols = 8;
export const MaximumCommentLengthValidationError = 500;
